<template>
  <div>
    <!-- {{imageUrl!==''?imageUrl:image}} -->
    <el-upload class="avatar-uploader" :headers="headers" :action="$api.uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">

      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <img v-if="!imageUrl&&image" :src="image" class="avatar">
      <i v-if="image==''&&imageUrl==''" class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>

</template>



<script>
export default {
  props: ["image"],
  data() {
    return {
      imageUrl: '',
      headers: {
        'token': this.$cookies.get('sso_token'),
        'userId': this.$cookies.get('sso_userId')
      },
    };
  },
  watch: {},
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(res)
      this.$emit("get-photo", res.data);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  },
  mounted() {
    // console.log(this.image)
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 180px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 140px;
  height: 180px;
  display: block;
}
</style>